export default __webpack_public_path__ + "static/media/founderIcon.54c997e5.png";